import { SelectionObserver } from './selection-observer';

export {
  SelectionObserver
}
